import React from 'react';

const GoogleMap:React.FC = ()=>{
  return(
    <div className="ecn-map mt-2">
<iframe title="ECN Location" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14128.752263690776!2d85.30679608406983!3d27.711479078078344!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x9aeff34685cd7502!2sElection%20Commission%2C%20Nepal!5e0!3m2!1sen!2snp!4v1626934455141!5m2!1sen!2snp" width="600" height="450"  loading="lazy"></iframe>    </div>
  );
}


export default GoogleMap;
